// import React, { useState, useEffect } from "react";
// import "./registrationfrom.css";
// import Address from "./Address";
// import JobDetails from "./JobDetails";
// import CustomFields from "./CustomFields";
// import PersonalInfo from "./PersonalInfo";
// import InterogativeImg from "../../Assets/Images/CommanImages/Informative.png";
// import WarnningIcon from "../../Assets/Images/CommanImages/Warning.png";
// import ErrorIcon from "../../Assets/Images/CommanImages/Error.png";
// import Cropper from "react-easy-crop";
// import EndPoints from "../../Api/Endpoints";

// function EmployeeRegistration({ dataClient, setMessageBox, messageBox, setIsMessageBoxVisible, setActiveImg, setNoTimeSet,  setMessageBoxHeight }) {
//   const [personalInfo, setPersonalInfo] = useState({});
//   const [address, setAddress] = useState({});
//   const [jobDetails, setJobDetails] = useState({});

//   const user_name = dataClient?.client_schema_name[6][0].user_name;
//   const client_id = dataClient?.client_schema_name[6][0].client_id;
//   const client_branch_id = dataClient?.client_schema_name[6][0].client_branch_id;

//   const handleSubmit = async () => {
//     try {
//       const validationErrors = validateForm();

//       if (validationErrors.length > 0) {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{validationErrors}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(ErrorIcon);
//         setMessageBoxHeight("auto");
//         return;
//       }
//       const accessToken = localStorage.getItem("other");

//       const formData = new FormData();
//       const employeePayload = {
//         client_id,
//         client_branch_id,
//         age_as_on: new Date().toISOString(),
//         landline: null,
//         signature: null,
//         delete_flag: null,
//         last_modified_date: new Date().toISOString(),
//         last_modified_by: user_name,
//         create_date: new Date().toISOString(),
//         created_by: user_name,
//         last_modified_screen_id: 1,
//         ...personalInfo,
//         ...address,
//         ...jobDetails,
//       };

//       // Remove the IMG blob — it goes as a separate multipart field
//       delete employeePayload.IMG;

//       // Fix field name mismatch: component uses "emrgency_contact_mob_no"
//       // but API expects "emergency_contact_mob_no"
//       if (employeePayload.emrgency_contact_mob_no !== undefined) {
//         employeePayload.emergency_contact_mob_no =
//           employeePayload.emrgency_contact_mob_no;
//         delete employeePayload.emrgency_contact_mob_no;
//       }

//       formData.append("employee_data", JSON.stringify(employeePayload));

//       // Only append photograph if one was actually selected
//       if (personalInfo.IMG) {
//         formData.append("photograph", personalInfo.IMG, personalInfo.IMG.name);
//       }

//       const response = await fetch(EndPoints.PRISM_NEW_EMPLOYEE, {
//         method: "POST",
//         headers: {
//           "Authorization": `Bearer ${accessToken}`,
//           "accept": "application/json",
//         },
//         body: formData,
//       });

//       const responseData = await response.json();
//       if (response.ok) {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{responseData.message || "Employee registered successfully."}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(InterogativeImg);
//         setMessageBoxHeight("10vh");
//         setTimeout(() => {
//           window.location.reload();
//         }, 1500);
//         return;
//       }
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{responseData.message || "Failed to register employee."}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(WarnningIcon);
//       setMessageBoxHeight("10vh");
//       return;
//     } catch (error) {
//       // Handle network errors or unexpected errors
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{error.message || "An error occurred. Please try again."}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(WarnningIcon);
//       setMessageBoxHeight("10vh");
//       window.scrollTo({ top: 0, behavior: "smooth" });
//     }
//   };

//   const validateForm = () => {
//     const errors = [];

//     if (!personalInfo.salutation_id) errors.push("Salutation is required.");
//     if (personalInfo.gender_id === null) errors.push("Gender is required.");
//     if (!personalInfo.blood_group_id) errors.push("Blood group is required.");
//     if (!personalInfo.religion_id) errors.push("Religion is required.");
//     if (personalInfo.category_id === 0) errors.push("Category is required.");
//     if (!personalInfo.emp_first_name) errors.push("First name is required.");
//     if (!personalInfo.emp_last_name) errors.push("Last name is required.");
//     if (!personalInfo.age) errors.push("Age is required.");
//     if (personalInfo.married_flag === null)
//       errors.push("Marital status is required.");
//     if (!personalInfo.fathers_name) errors.push("Father's name is required.");

//     if (!address.loc_add1) errors.push("Local address is required.");
//     if (address.loc_city_id === null) errors.push("Local city is required.");
//     if (!address.perm_add1) errors.push("Permanent address is required.");
//     if (!address.perm_city_id) errors.push("Permanent city is required.");
//     if (address.prim_mob_no === null)
//       errors.push("Primary mobile number is required.");

//     if (!jobDetails.staff_number) errors.push("Staff number is required.");
//     if (!jobDetails.hire_date) errors.push("Hire date is required.");
//     if (jobDetails.department_id === null)
//       errors.push("Department is required.");
//     if (jobDetails.grade_id === null) errors.push("Grade is required.");
//     if (jobDetails.designation_id === null)
//       errors.push("Designation is required.");
//     if (!jobDetails.emp_type) errors.push("Employee type is required.");
//     if (!jobDetails.status) errors.push("Status is required.");
//     if (jobDetails.manager_emp_id === null)
//       errors.push("Manager Employee ID is required.");

//     return errors;
//   };

//   const handleCancel = () => {
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Your changes will be lost. Do you want to continue?</span>
//         </div>

//         <div className="messagebox-insider2" style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
//           <button
//             className="messagebox-cancel-btn-ok"
//             onClick={() => {
//               setIsMessageBoxVisible(false);
//               resetForm(); 
//             }}
//           >
//             YES
//           </button>

//           <button
//             className="messagebox-cancel-btn-ok"
//             onClick={() => {
//               // just close the box
//               setIsMessageBoxVisible(false);
//             }}
//           >
//             NO
//           </button>
//         </div>
//       </div>
//     );
//     setActiveImg(WarnningIcon);
//     setIsMessageBoxVisible(true);
//     setMessageBoxHeight("10vh");
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const resetForm = () => {
//     setPersonalInfo({});
//     setJobDetails({});
//     setAddress({});
//     setTimeout(() => {
//       window.location.reload();
//     }, 1000);
//   };

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-one">
//         <span className="create-role-heading">Employee Registration Form</span>
//         <div className="cr-header-btn-container">
//           <button className="cr-cancel-btn" onClick={handleCancel}>
//             CANCEL
//           </button>
//           <button
//             className="cr-create-btn"
//             onClick={handleSubmit}
//             style={{ backgroundColor: "#424342", color: "white" }}
//           >
//             SAVE
//           </button>
//         </div>
//       </div>
//       <PersonalInfo setPersonalInfo={setPersonalInfo} />
//       <Address setAddress={setAddress} />
//       <JobDetails setJobDetails={setJobDetails} />
//       <CustomFields />
//     </div>
//   );
// }
// export default EmployeeRegistration;





import React, { useState, useEffect } from "react";
import "./registrationfrom.css";
import Address from "./Address";
import JobDetails from "./JobDetails";
import CustomFields from "./CustomFields";
import PersonalInfo from "./PersonalInfo";
import InterogativeImg from "../../Assets/Images/CommanImages/Informative.png";
import WarnningIcon from "../../Assets/Images/CommanImages/Warning.png";
import Cropper from "react-easy-crop";
import EndPoints from "../../Api/Endpoints";

function EmployeeRegistration({ dataClient, setMessageBox, messageBox, setIsMessageBoxVisible, setActiveImg, setNoTimeSet, setMessageBoxHeight }) {
  const [personalInfo, setPersonalInfo] = useState({});
  const [address, setAddress] = useState({});
  const [jobDetails, setJobDetails] = useState({});

  const user_name = dataClient?.client_schema_name[6][0].user_name;
  const client_id = dataClient?.client_schema_name[6][0].client_id;
  const client_branch_id = dataClient?.client_schema_name[6][0].client_branch_id;

  const handleSubmit = async () => {
    try {
      const validationErrors = validateForm();

      if (validationErrors.length > 0) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{validationErrors}</span>
            </div>
          </div>
        );
        setActiveImg(WarnningIcon);
        setMessageBoxHeight("auto");
        return;
      }

      const accessToken = localStorage.getItem("other");
      const formData = new FormData();

      // Always append photograph — real file or empty blob fallback
      if (personalInfo.IMG) {
        formData.append("photograph", personalInfo.IMG, personalInfo.IMG.name);
      } else {
        const emptyFile = new Blob([""], { type: "image/png" });
        formData.append("photograph", emptyFile, "empty.png");
      }

      const employeePayload = {
        client_id,
        client_branch_id,
        age_as_on: new Date().toISOString(),
        landline: null,
        signature: null,
        delete_flag: null,
        last_modified_date: new Date().toISOString(),
        last_modified_by: user_name,
        create_date: new Date().toISOString(),
        created_by: user_name,
        last_modified_screen_id: 1,
        ...personalInfo,
        ...address,
        ...jobDetails,
      };

      // Remove file/blob fields — they must NOT appear in the JSON payload
      delete employeePayload.IMG;
      delete employeePayload.photograph;

      // Fix field name mismatch
      if (employeePayload.emrgency_contact_mob_no !== undefined) {
        employeePayload.emergency_contact_mob_no = employeePayload.emrgency_contact_mob_no;
        delete employeePayload.emrgency_contact_mob_no;
      }

      formData.append("employee_data", JSON.stringify(employeePayload));

      const response = await fetch(EndPoints.PRISM_NEW_EMPLOYEE, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${accessToken}`,
          "accept": "application/json",
        },
        body: formData,
      });

      const responseData = await response.json();

      if (response.ok && responseData.status === 200 && responseData.emp_id) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{responseData.message || "Employee registered successfully."}</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
        setMessageBoxHeight("10vh");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
        return;
      }

      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{responseData.message || "Failed to register employee."}</span>
          </div>
        </div>
      );
      setActiveImg(WarnningIcon);
      setMessageBoxHeight("10vh");

    } catch (error) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>{error.message || "An error occurred. Please try again."}</span>
          </div>
        </div>
      );
      setActiveImg(WarnningIcon);
      setMessageBoxHeight("10vh");
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const validateForm = () => {
    const errors = [];

    if (!personalInfo.salutation_id) errors.push("Salutation is required.");
    if (personalInfo.gender_id === null) errors.push("Gender is required.");
    if (!personalInfo.blood_group_id) errors.push("Blood group is required.");
    if (!personalInfo.religion_id) errors.push("Religion is required.");
    if (personalInfo.category_id === 0) errors.push("Category is required.");
    if (!personalInfo.emp_first_name) errors.push("First name is required.");
    if (!personalInfo.emp_last_name) errors.push("Last name is required.");
    if (!personalInfo.age) errors.push("Age is required.");
    if (personalInfo.married_flag === null) errors.push("Marital status is required.");
    if (!personalInfo.fathers_name) errors.push("Father's name is required.");

    if (!address.loc_add1) errors.push("Local address is required.");
    if (address.loc_city_id === null) errors.push("Local city is required.");
    if (!address.perm_add1) errors.push("Permanent address is required.");
    if (!address.perm_city_id) errors.push("Permanent city is required.");
    if (address.prim_mob_no === null) errors.push("Primary mobile number is required.");

    if (!jobDetails.staff_number) errors.push("Staff number is required.");
    if (!jobDetails.hire_date) errors.push("Hire date is required.");
    if (jobDetails.department_id === null) errors.push("Department is required.");
    if (jobDetails.grade_id === null) errors.push("Grade is required.");
    if (jobDetails.designation_id === null) errors.push("Designation is required.");
    if (!jobDetails.emp_type) errors.push("Employee type is required.");
    if (!jobDetails.status) errors.push("Status is required.");
    if (jobDetails.manager_emp_id === null) errors.push("Manager Employee ID is required.");

    return errors;
  };

  const handleCancel = () => {
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>Your changes will be lost. Do you want to continue?</span>
        </div>
        <div className="messagebox-insider2" style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => {
              setIsMessageBoxVisible(false);
              resetForm();
            }}
          >
            YES
          </button>
          <button
            className="messagebox-cancel-btn-ok"
            onClick={() => {
              setIsMessageBoxVisible(false);
            }}
          >
            NO
          </button>
        </div>
      </div>
    );
    setActiveImg(WarnningIcon);
    setIsMessageBoxVisible(true);
    setMessageBoxHeight("10vh");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const resetForm = () => {
    setPersonalInfo({});
    setJobDetails({});
    setAddress({});
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  return (
    <div className="create-role-container">
      <div className="create-role-container-one">
        <span className="create-role-heading">Employee Registration Form</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={handleCancel}>
            CANCEL
          </button>
          <button
            className="cr-create-btn"
            onClick={handleSubmit}
            style={{ backgroundColor: "#424342", color: "white" }}
          >
            SAVE
          </button>
        </div>
      </div>
      <PersonalInfo setPersonalInfo={setPersonalInfo} />
      <Address setAddress={setAddress} />
      <JobDetails setJobDetails={setJobDetails} />
      <CustomFields />
    </div>
  );
}

export default EmployeeRegistration;

